/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, available: NonNullable<unknown>, unit: NonNullable<unknown> }} Stock_Out_Material_Lot_InfoInputs */

const vi_stock_out_material_lot_info = /** @type {(inputs: Stock_Out_Material_Lot_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lô ${i?.code} · còn ${i?.available} ${i?.unit}`)
};

/**

* @param {Stock_Out_Material_Lot_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_material_lot_info = /** @type {((inputs: Stock_Out_Material_Lot_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Material_Lot_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_material_lot_info(inputs)
});